module.exports = __webpack_public_path__ + "img/treehouse-badge.221ff6cc.png";